import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {initializeCurrentLocation, push} from "redux-little-router"

import Router from "../Router"
import StartupActions, {StartupTypes} from "./startup.redux"
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import FAQFlyout from "../../components/FAQFlyout"
import {checkEnv} from "../../utils"

import "./styles.css"

class App extends Component {
  static propTypes = {
    main_menu: PropTypes.object.isRequired,
    footer_menu: PropTypes.object.isRequired,
    topic_menu: PropTypes.array.isRequired,
    categories_menu: PropTypes.array.isRequired
  }

  static defaultProps = {
    main_menu: {},
    footer_menu: {},
    topic_menu: [],
    categories_menu: [],
    lang: "",
    num_bookmarks: null
  }

  componentDidMount() {
    // dispatch startup location
    const initialLocation = this.props.router
    if (initialLocation) {
      this.props.dispatch({
        ...initializeCurrentLocation(initialLocation),
        type: StartupTypes.STARTUP_ROUTER_LOCATION
      })
    }

    this.props.startup()
  }

  render() {
    if (
      typeof this.props.login !== "undefined" &&
      this.props.login.token !== null
    ) {
      return (
        <div className="App">
          <Header
            page={this.props.router.result.key}
            pathname={this.props.router.pathname}
            main_menu={this.props.main_menu}
            avatar={this.props.login.avatar}
            num_bookmarks={this.props.num_bookmarks}
            privacy_menu={this.props.footer_menu}
            unread_notifications_count={this.props.unread_notifications_count}
            notifications={this.props.notifications}
          />
          <Router />
          <Footer footer_menu={this.props.footer_menu} />
          {!checkEnv("DISABLE_FAQ_FLYOUT", true) && (
            <FAQFlyout
              categories={this.props.faq}
              lang={this.props.lang}
              push={this.props.push}
            />
          )}
        </div>
      )
    } else {
      return (
        <div className="App">
          <Router />
        </div>
      )
    }
  }
}

const mapStateToProps = state => {
  return {
    router: state.router,
    main_menu: state.app.main_menu,
    footer_menu: state.app.footer_menu,
    topic_menu: state.app.topic_menu,
    categories_menu: state.app.categories_menu,
    login: state.login,
    lang: state.app.lang,
    num_bookmarks: state.app.num_bookmarks,
    faq: state.app.faq,
    unread_notifications_count: state.app.unread_notifications_count,
    notifications: state.app.notifications
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
    push: path => dispatch(push(path)),
    startup: () => dispatch(StartupActions.startup())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/containers/App/index.js